var React = require('react');

function IconArticle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M800.5 146.5L545.8 401.2l75 74.9 254.7-254.7zM950.4 101.5l-30-30c-12-12-33-12-44.9 0l-59.9 59.9 74.9 74.9 59.9-59.9c11.9-11.9 11.9-33 0-44.9zM503.5 507.8c-1.7 5.3 3.2 10.4 8.5 8.9l91.8-24.9-72.1-72-28.2 88z","key":0}),React.createElement("path",{"d":"M861.4 383.8v495.4c0 6.6-5.4 12-12 12h-707c-6.6 0-12-5.4-12-12v-707c0-6.6 5.4-12 12-12h499.2V93.8H76c-6.6 0-12 5.4-12 12v839.8c0 6.6 5.4 12 12 12h839.8c6.6 0 12-5.4 12-12V383.8h-66.4z","key":1}),React.createElement("path",{"d":"M219.4 703h554.3c5.5 0 10 4.5 10 10v43.9c0 5.5-4.5 10-10 10H219.4c-5.5 0-10-4.5-10-10V713c0-5.5 4.5-10 10-10zM219.4 544h554.3c5.5 0 10 4.5 10 10v43.9c0 5.5-4.5 10-10 10H219.4c-5.5 0-10-4.5-10-10V554c0-5.5 4.5-10 10-10zM219.4 384h218.7c5.5 0 10 4.5 10 10v45.9c0 5.5-4.5 10-10 10H219.4c-5.5 0-10-4.5-10-10V394c0-5.5 4.5-10 10-10z","key":2})]);
}

IconArticle.displayName = "IconArticle";

IconArticle.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconArticle;

IconArticle.default = IconArticle;
